module.exports = __webpack_public_path__ + "static/media/ic_info.71aee4b6.svg";